import { useFetcher } from "~/hooks/useFetcher";
import { artifactLineagePath, type ArtifactLineageGraph } from "~/services/artifacts";

// Fetches the lineage graph for a single artifact. The endpoint lives on
// analysis-agent (with a TODO to move it to conversations-api), so we hit
// VITE_ANALYSIS_AGENT_API rather than VITE_CONVERSATIONS_API. The renderer
// only ever consumes `mermaid`; the structured node/edge arrays are
// exposed for cases that want to count or filter without parsing the
// diagram.
export function useArtifactLineage(conversationId: string, artifactId: string) {
  const { data, error, isLoading } = useFetcher<ArtifactLineageGraph>(
    artifactLineagePath(conversationId, artifactId)
  );
  return { lineage: data, error, isLoading };
}
